import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';
import { isNumberGreaterThanZero } from '@thesavingsgroup/utils/isNumberGreaterThanZero';
import toNumber from 'lodash/toNumber';

import { RefinanceGoal } from '../enums/RefinanceGoal';
import { SearchVehicle } from '../enums/SearchVehicle';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromMailCode } from '../types/HydrateFromMailCode';
import { VehicleIdentifiers } from '../types/VehicleIdentifiers';
import { isValidVin } from './isValidVin';

export const toApplyStateFromMailCode = async (
  mailCode: HydrateFromMailCode,
  findVehicleByVin: (vin: string) => Promise<VehicleIdentifiers | null>,
): Promise<Partial<ApplyState>> => {
  const applicationType = isInEnum(mailCode.applicationType, ApplicationType)
    ? mailCode.applicationType
    : ApplicationType.REFINANCE;

  const isRefinance = applicationType === ApplicationType.REFINANCE;

  const isPurchaseOrLeaseBuyout =
    applicationType === ApplicationType.PURCHASE ||
    applicationType === ApplicationType.LEASE_BUYOUT;

  const payoffAmount: string | null = isRefinance
    ? mailCode.payoffAmount
    : null;

  const purchasePrice: string | null =
    isPurchaseOrLeaseBuyout &&
    isNumberGreaterThanZero(toNumber(mailCode.purchasePrice))
      ? String(mailCode.purchasePrice)
      : null;

  const refinanceGoal: RefinanceGoal | null = isRefinance
    ? RefinanceGoal.LOWER_PAYMENT
    : null;

  const vin = isValidVin(mailCode.vin) ? mailCode.vin : null;

  const searchVehicle: SearchVehicle | null = vin ? SearchVehicle.BY_VIN : null;

  const vehicle = vin ? await findVehicleByVin(vin) : null;

  const make = vehicle?.make || null;
  const model = vehicle?.model || null;
  const trim = vehicle?.trim || null;
  const year = vehicle?.year || null;

  return {
    applicationType,
    make,
    model,
    payoffAmount,
    purchasePrice,
    refinanceGoal,
    searchVehicle,
    trim,
    vin,
    year,
  };
};
